<div class="container-table">
  <app-table [dataTable]="dataTable" [key]="tipoTabla" [showPagination]="false" [rowSelection]="true" ></app-table>
</div>
